/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react'
import { swalMessages } from 'src/constants'
import MaterialTable from 'material-table'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput'
import reportRequestPermissionsService from 'src/services/reportRequestPermissionsService'
import convertDate from 'src/utils/formatDate'
import { loaderService } from 'src/services/loaderService'
import { permitsList } from 'src/constants/permits'
import { Context } from 'src/context/Contex'

const initialState = { descripcionEstado: ' ' }

const AdminReportRequestPermissions = () => {
  const [requestPermission, setRequestPermission] = useState([])
  const [aceptOrReject, setAceptOrReject] = useState('')
  const [create, setCreate] = useState(initialState)
  const [openModal, setOpenModal] = useState(false)
  const handleClose = () => setOpenModal(false)
  const [idAcept, setIdAcept] = useState('')

  const date = new Date()
  const { permisos } = useContext(Context)
  const permitValue =
    permisos[permitsList.ADMIN_SOLICITUD_PERMISO_REPORTE_DATASTUDIO]

  // obtener solicitudes de Permisos
  const getPermissionRequests = async () => {
    const {
      success,
      data = [],
    } = await reportRequestPermissionsService.getListPermission()
    if (success == 1) {
      setRequestPermission(data)
    } else {
      swal(swalMessages.WARNING_DATASTUDIO)
    }
  }

  // Aceptar o rechazar solicitud permiso acceso a reporte

  const aceptPermissionReport = async (event) => {
    loaderService.show()
    event.preventDefault()
    const body = {
      ...create,
      id: idAcept,
      tipo: aceptOrReject == 'completar' ? 'completar' : 'rechazar',
    }
    const response = await reportRequestPermissionsService.putApproveReject(
      body,
    )
    setOpenModal(true)
    if (!response.status) {
      swal({
        title: 'Upsss!!!!',
        text: response.data.error,
        icon: 'warning',
        button: 'Cerrar!',
        dangerMode: true,
      })
    } else if (aceptOrReject == 'completar') {
        swal(swalMessages.SUCCESSFUL_APPROVAL)
        getPermissionRequests()
      } else {
        swal(swalMessages.SUCCESFUL_REJECT)
        getPermissionRequests()
      }
    loaderService.hide()
    setOpenModal(false)
    setCreate(initialState)
  }

  const onChangeInput = (event, type) => {
    setCreate({
      descripcionEstado:
        type === 'descripcionEstado' ? event.target.value : ' ',
    })
  }

  useEffect(() => {
    getPermissionRequests()
  }, [])

  const aceptRequest = (event, tipo) => {
    if (tipo == 'completar') {
      setAceptOrReject('completar')
      setOpenModal(true)
      setIdAcept(event.id)
    } else {
      setAceptOrReject('rechazar')
      setOpenModal(true)
      setIdAcept(event.id)
    }
  }
  const onDeleteRequest = (rowData) => {
    const {id} = rowData
    swal(swalMessages.DELETE_CONFIRM).then(async(willDelete) => {
      if (willDelete) {
        const {success} = await reportRequestPermissionsService.deleteRequest(id)
        if (success) {
          const updatedRequest = requestPermission.filter(rqst => rqst.id !== id)
          setRequestPermission(updatedRequest)
          swal(swalMessages.SUCCEFUL_DELETE)
        } else {
          swal(swalMessages.GENERAL_ERROR)
        }
      }
    })
  }
  // console.log(requestPermission)

  return (
    <>
      <main style={{ margin: '10px' }}>
        <CardTitle
          title="Administración solicitud de reportes"
          subTitle=" Aprobación o rechazo de solicitud de reportes"
        />

        <MaterialTable
          style={{ color: 'ff9800' }}
          title="Solicitudes"
          columns={[
            { title: 'Fecha', field: 'Fecha' },
            { title: 'Reporte', field: 'Reporte' },
            { title: 'Correo', field: 'Correo' },
            { title: 'Estado', field: 'Estado' },
          ]}
          data={requestPermission?.map((item) => ({
            id: item.id,
            Fecha: convertDate(date),
            Reporte: item.reporte.nombre,
            Correo: item.correo,
            Estado: item.estado,
          }))}
          actions={
            permitValue >= 3
              ? [
                  {
                    icon: 'check',
                    tooltip: 'Aprobar solicitud',
                    onClick: (event, rowData) =>
                      aceptRequest(rowData, 'completar'),
                  },
                  () => ({
                    icon: 'clear',
                    tooltip: 'Rechazar solicitud',
                    onClick: (event, rowData) =>
                      aceptRequest(rowData, 'rechazar'),
                  }),
                  {
                    icon: 'delete',
                    tooltip: 'Eliminar solicitud',
                    onClick: (event, rowData) => onDeleteRequest(rowData),
                    hidden: permitValue < 4,
                  },
                ]
              : false
          }
          options={{
            actionsColumnIndex: -1,
          }}
        />
        <>
          <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" />
            <DialogContent style={{ width: '30rem' }}>
              <DialogContentText id="alert-dialog-description">
                <h4>Formulario Aprobación/Rechazo</h4>
              </DialogContentText>
              <CustomInput
                labelText="Descripcion"
                id="descripcionEstado"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  value: create.descripcionEstado || '',
                  onChange: (event) =>
                    onChangeInput(event, 'descripcionEstado'),
                  type: 'text',
                  autoComplete: 'off',
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="warning">
                Cancelar
              </Button>
              <Button
                autoFocus
                type="onSubmit"
                color="warning"
                onClick={aceptPermissionReport}
              >
                Completar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      </main>
    </>
  )
}

export default AdminReportRequestPermissions
